module.exports = __webpack_public_path__ + "img/rekap_presensi.52605eac.png";